import {
  getMediaGalleryEntries 
} from "@/util/getProductImage"
import {
  useMemo 
} from "react"

export const useGetMediaGalleryEntries = ({
  product,
  optionCodes,
  optionSelections
}) => {
  const mediaGalleryEntries = useMemo(
    () => getMediaGalleryEntries(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections]
  )

  const galleryImages = useMemo(() => {
    const images = []

    if (!mediaGalleryEntries) { return }

    // 深拷贝一个mediaGalleryEntries
    const mediaGalleryEntriesClone = JSON.parse(JSON.stringify(mediaGalleryEntries))

    // 根据mediaGalleryEntries.postion对mediaGalleryEntries排序
    // 写一个冒泡排序
    for (let i = 0; i < mediaGalleryEntriesClone.length; i++) {
      for (let j = 0; j < mediaGalleryEntriesClone.length - i - 1; j++) {
        if (
          mediaGalleryEntriesClone[j].position >
                    mediaGalleryEntriesClone[j + 1].position
        ) {
          const temp = mediaGalleryEntriesClone[j]

          mediaGalleryEntriesClone[j] =
                        mediaGalleryEntriesClone[j + 1]
          mediaGalleryEntriesClone[j + 1] = temp
        }
      }
    }

    mediaGalleryEntriesClone.forEach((item, index) => {
      images.push({
        file: item.url,
        label: item.label,
        thumbnail: mediaGalleryEntriesClone[index]?.url,
      })
    })

    return images
  }, [product, optionCodes, optionSelections, mediaGalleryEntries])

  return {
    mediaGalleryEntries,
    galleryImages
  }
}
